var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup25854(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278.218,
    height: 81.354,
    viewBox: "0 0 278.218 81.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_7580",
    x: 56.445,
    y: 11.7,
    width: 49.439,
    height: 55.154,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7581",
    x: 90.398,
    y: 9.357,
    width: 40.578,
    height: 56.468,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7582",
    x: 115.663,
    y: 26.104,
    width: 40.578,
    height: 40.637,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7583",
    x: 140.926,
    y: 27.076,
    width: 40.409,
    height: 39.664,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7584",
    x: 166.19,
    y: 8.5,
    width: 32.919,
    height: 57.325,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7585",
    x: 182.31,
    y: 8.5,
    width: 32.919,
    height: 57.325,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7586",
    x: 198.429,
    y: 26.104,
    width: 40.579,
    height: 40.637,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7587",
    x: 223.693,
    y: 27.076,
    width: 40.408,
    height: 39.664,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7588",
    x: 248.957,
    y: 26.104,
    width: 29.261,
    height: 39.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7589",
    x: 0,
    y: 25.347,
    width: 54.409,
    height: 56.006,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25854",
    "data-name": "Group 25854",
    transform: "translate(362.271 -214.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23580",
    "data-name": "Group 23580",
    transform: "translate(-296.826 228.899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7580-2",
    "data-name": "Path 7580",
    d: "M-298.595,254.079a15.483,15.483,0,0,0,4,10.469q4,4.593,10.918,4.594a15.326,15.326,0,0,0,5.458-1.029,13.583,13.583,0,0,0,4.831-3.145l2.63,2.517a19.98,19.98,0,0,1-5.974,3.858,17.8,17.8,0,0,1-6.944,1.4,17.761,17.761,0,0,1-13.09-5.478,18.054,18.054,0,0,1-5.431-13.186,17.792,17.792,0,0,1,5.431-13.068,17.85,17.85,0,0,1,13.09-5.423,18.094,18.094,0,0,1,6.973,1.344,19.047,19.047,0,0,1,5.946,3.916l-2.63,2.514a13.675,13.675,0,0,0-4.773-3.143,15.142,15.142,0,0,0-5.515-1.03q-6.917,0-10.918,4.536A15.21,15.21,0,0,0-298.595,254.079Z",
    transform: "translate(367.64 -217.89)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7581-2",
    "data-name": "Path 7581",
    d: "M-237.8,260.767v10.4h-3.6V260.735a7.426,7.426,0,0,0-2.23-5.447,7.449,7.449,0,0,0-5.488-2.236,7.381,7.381,0,0,0-5.43,2.236,7.429,7.429,0,0,0-2.229,5.447v10.436h-3.6V232.7h3.6v19.834a10.777,10.777,0,0,1,7.659-3.087,10.909,10.909,0,0,1,8,3.316A10.908,10.908,0,0,1-237.8,260.767Z",
    transform: "translate(359.78 -217.35)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7582-2",
    "data-name": "Path 7582",
    d: "M-210.292,272.933a11.288,11.288,0,0,1-3.545,2.257,11.176,11.176,0,0,1-4.172.773,10.835,10.835,0,0,1-7.946-3.316,10.9,10.9,0,0,1-3.315-8,10.979,10.979,0,0,1,3.287-7.973,10.762,10.762,0,0,1,7.973-3.345,10.741,10.741,0,0,1,7.717,3.145V254.3h3.6v20.749h-3.6Zm-7.717-16a7.373,7.373,0,0,0-5.43,2.239,7.426,7.426,0,0,0-2.229,5.449,7.556,7.556,0,0,0,2.229,5.451,7.286,7.286,0,0,0,5.43,2.294,7.443,7.443,0,0,0,5.488-2.236,7.5,7.5,0,0,0,2.23-5.509,7.424,7.424,0,0,0-2.23-5.449A7.442,7.442,0,0,0-218.01,256.928Z",
    transform: "translate(353.93 -221.22)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7583-2",
    "data-name": "Path 7583",
    d: "M-187.069,276.188a10.581,10.581,0,0,1-7.8-3.334,10.936,10.936,0,0,1-3.288-7.955V254.524h3.6v10.37a7.478,7.478,0,0,0,2.228,5.412,7.112,7.112,0,0,0,5.26,2.279,7.473,7.473,0,0,0,5.488-2.222,7.418,7.418,0,0,0,2.227-5.47v-10.37h3.6V264.9a10.863,10.863,0,0,1-3.316,7.982A10.92,10.92,0,0,1-187.069,276.188Z",
    transform: "translate(348.08 -221.45)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7584-2",
    "data-name": "Path 7584",
    d: "M-152.127,231.647v3.6a7.517,7.517,0,0,0-5.431,2.23,7.3,7.3,0,0,0-2.285,5.43v7.259h3.657v3.6h-3.657v17.2h-3.6v-17.2h-3.6v-3.6h3.6v-7.259a10.843,10.843,0,0,1,3.314-7.946A10.908,10.908,0,0,1-152.127,231.647Z",
    transform: "translate(342.24 -217.15)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7585-2",
    "data-name": "Path 7585",
    d: "M-132.275,231.647v3.6a7.513,7.513,0,0,0-5.431,2.23,7.291,7.291,0,0,0-2.286,5.43v7.259h3.658v3.6h-3.658v17.2h-3.6v-17.2h-3.6v-3.6h3.6v-7.259a10.836,10.836,0,0,1,3.316-7.946A10.9,10.9,0,0,1-132.275,231.647Z",
    transform: "translate(338.5 -217.15)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7586-2",
    "data-name": "Path 7586",
    d: "M-123.513,266.417a7.746,7.746,0,0,0,2.656,4.27,7.267,7.267,0,0,0,4.773,1.674,7.556,7.556,0,0,0,2.772-.5,6.9,6.9,0,0,0,2.316-1.5l2.63,2.572a11.307,11.307,0,0,1-3.545,2.257,11.183,11.183,0,0,1-4.173.773,10.833,10.833,0,0,1-7.945-3.316,10.9,10.9,0,0,1-3.315-8,10.982,10.982,0,0,1,3.287-7.973,10.763,10.763,0,0,1,7.973-3.345,10.925,10.925,0,0,1,8,3.3,10.839,10.839,0,0,1,3.316,7.968v1.821Zm0-3.6h14.918a7.565,7.565,0,0,0-2.687-4.243,7.464,7.464,0,0,0-4.8-1.645,7.457,7.457,0,0,0-4.744,1.674A7.281,7.281,0,0,0-123.513,262.816Z",
    transform: "translate(334.77 -221.22)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7587-2",
    "data-name": "Path 7587",
    d: "M-85.142,276.188a10.581,10.581,0,0,1-7.8-3.334,10.942,10.942,0,0,1-3.287-7.955V254.524h3.6v10.37a7.477,7.477,0,0,0,2.227,5.412,7.112,7.112,0,0,0,5.259,2.279,7.473,7.473,0,0,0,5.488-2.222,7.418,7.418,0,0,0,2.227-5.47v-10.37h3.6V264.9a10.863,10.863,0,0,1-3.316,7.982A10.92,10.92,0,0,1-85.142,276.188Z",
    transform: "translate(328.92 -221.45)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -65.45, -14.5)",
    filter: "url(#Path_7588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7588-2",
    "data-name": "Path 7588",
    d: "M-53.858,253.326v3.6a7.38,7.38,0,0,0-5.431,2.236,7.43,7.43,0,0,0-2.23,5.447v10.436h-3.6V254.3h3.6v2.172A10.675,10.675,0,0,1-53.858,253.326Z",
    transform: "translate(323.08 -221.22)",
    fill: "#6e2a73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23581",
    "data-name": "Group 23581",
    transform: "translate(-358.387 214.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3.88, 0)",
    filter: "url(#Path_7589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7589-2",
    "data-name": "Path 7589",
    d: "M-371.422,251.4a18.1,18.1,0,0,0-1.842,7.941c0,10.054,18.2,30.065,18.2,30.065s18.205-20.012,18.205-30.065A18.1,18.1,0,0,0-338.7,251.4a49.322,49.322,0,0,1-16.362,2.452A49.324,49.324,0,0,1-371.422,251.4Zm21.91,10.17a5.548,5.548,0,0,1-5.548,5.548,5.548,5.548,0,0,1-5.548-5.548,5.548,5.548,0,0,1,5.548-5.548A5.548,5.548,0,0,1-349.512,261.567Z",
    transform: "translate(382.26 -220.05)",
    fill: "#6e2a73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7590",
    "data-name": "Path 7590",
    d: "M-373.841,230.028l1.095-.4a49.365,49.365,0,0,1,16.414-2.456,49.37,49.37,0,0,1,16.414,2.456l1.095.4.382,1.1.431,1.245c2.675-1.843,4.809-3.924,5-6.851-.257-3.959-4.066-6.375-7.967-8.739-4.154-2.221-8.4-4.388-15.354-4.534-6.956.146-11.2,2.313-15.354,4.534-3.9,2.364-7.71,4.78-7.966,8.739.19,2.927,2.325,5.008,5,6.851l.432-1.244Z",
    transform: "translate(379.653 -212.251)",
    fill: "#6e2a73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7591",
    "data-name": "Path 7591",
    d: "M-373.443,244.3c3.572,2.148,10.448,3.6,18.348,3.6s14.777-1.456,18.348-3.6l-2.788-8.043a47.189,47.189,0,0,0-15.561-2.3,47.2,47.2,0,0,0-15.561,2.3Z",
    transform: "translate(378.416 -216.575)",
    fill: "#6e2a73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25854);
export default __webpack_public_path__ + "static/media/Group 25854.759ceaab74030b58dca3fca9fa2f3933.svg";
export { ForwardRef as ReactComponent };